<template>
  <div class="org-manage">
    <el-card shadow="never">
      <div class="search-area">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="机构品牌">
            <el-input v-model="searchForm.orgName" placeholder="请输入机构品牌" clearable />
          </el-form-item>
          <el-form-item label="授课方式">
            <el-select v-model="searchForm.teachModeCode" placeholder="请选择" clearable>
              <el-option label="线上" value="ONLINE" />
              <el-option label="线下" value="OFFLINE" />
              <el-option label="混合" value="HYBRID" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.statusCode" placeholder="请选择" clearable>
              <el-option label="运营中" value="RUNNING" />
              <el-option label="已暂停" value="PAUSED" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch" :loading="searchLoading">查询</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          </el-form-item>
          <el-form-item v-if="canShowOrgWriteActions">
            <el-button icon="el-icon-plus" @click="handleAdd">新增机构</el-button>
          </el-form-item>
        </el-form>
        <div class="btn-group">
          <el-button v-if="canShowManageListDelete" icon="el-icon-delete" :disabled="!selectedRows.length" @click="handleBatchDelete" :loading="batchDeleteLoading">批量删除</el-button>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="table-card">
      <el-table :data="tableData" v-loading="loading" border stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" :selectable="orgRowSelectable" />
        <el-table-column type="index" label="序号" width="60" :index="indexMethod" />
        <el-table-column prop="orgCode" label="机构编码" width="100" />
        <el-table-column prop="orgName" label="机构品牌" min-width="150" />
        <el-table-column prop="teachModeName" label="授课方式" width="100" />
        <el-table-column label="主营项目" min-width="200" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ formatMainProjects(row.mainProjectCodes) || row.mainProjectDesc || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag :type="row.statusCode === 'RUNNING' ? 'success' : 'info'">{{ row.statusName || row.statusCode }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createByName" label="创建人" width="120" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="160" />
        <el-table-column label="操作" width="200">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleDetail(row)">详情</el-button>
            <el-button v-if="canShowOrgRowEdit" type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button v-if="canShowManageListDelete" type="text" class="danger-btn" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="pagination-wrapper">
      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1280px" :close-on-click-modal="false" @close="resetForm" @open="onDialogOpen">
      <el-form :model="form" :rules="orgDialogRules" ref="form" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="机构编码" prop="orgCode">
              <el-input v-model="form.orgCode" placeholder="自动生成" readonly style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="org-dialog-first-row">
          <el-col :span="6">
            <el-form-item label="机构品牌" prop="orgName">
              <el-input v-model="form.orgName" placeholder="请输入机构品牌" style="width: 100%;" clearable :disabled="isDetailReadOnly" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="授课方式" prop="teachModeCode">
              <el-select v-model="form.teachModeCode" placeholder="请选择授课方式" style="width: 100%;" :disabled="isDetailReadOnly">
                <el-option label="线上" value="ONLINE" />
                <el-option label="线下" value="OFFLINE" />
                <el-option label="混合" value="HYBRID" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="主营项目" prop="mainProjectCodes">
              <el-cascader
                v-model="form.mainProjectCodes"
                :options="projectOptions"
                :props="{ multiple: true, checkStrictly: true, emitPath: false, expandTrigger: 'hover' }"
                placeholder="请选择主营项目"
                style="width: 100%;"
                clearable
                filterable
                collapse-tags
                :disabled="isDetailReadOnly"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="运营状态" prop="statusCode">
              <el-select v-model="form.statusCode" placeholder="请选择运营状态" style="width: 100%;" :disabled="isDetailReadOnly">
                <el-option label="运营中" value="RUNNING" />
                <el-option label="已暂停" value="PAUSED" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="remark">
          <el-input 
            type="textarea" 
            v-model="form.remark" 
            :rows="3" 
            placeholder="请输入备注（最多2000字）" 
            :maxlength="ORG_REMARK_MAX_LENGTH"
            show-word-limit
            :disabled="isDetailReadOnly"
          />
        </el-form-item>
        <el-tabs v-model="activeTab" type="card" class="org-dialog-tabs">
          <el-tab-pane v-if="canShowOrgBusinessTab" label="商务信息" name="business">
          <div class="tab-pane-content">
            <el-collapse v-model="businessActiveNames" class="org-business-collapse">
              <el-collapse-item name="cooperationInfo" title="合作信息">
                <div v-for="(item, index) in form.principals" :key="index" class="principal-row">
                  <el-row :gutter="20" type="flex" align="middle">
                    <el-col :span="12">
                      <el-form-item :label="index === 0 ? '负责人姓名' : ''" :prop="'principals.' + index + '.name'" :rules="rules.principalName" label-width="120px">
                        <el-input v-model="item.name" placeholder="请输入负责人姓名" style="width: 100%;" clearable :disabled="isDetailReadOnly" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="9">
                      <el-form-item :label="index === 0 ? '负责人电话' : ''" :prop="'principals.' + index + '.phone'" :rules="rules.principalPhone" label-width="120px">
                        <el-input v-model="item.phone" placeholder="请输入负责人电话" style="width: 100%;" clearable :disabled="isDetailReadOnly" />
                      </el-form-item>
                    </el-col>
                    <el-col v-if="!isDetailReadOnly" :span="3" class="principal-actions-col">
                      <div class="principal-actions">
                        <div
                          v-if="form.principals.length < 5 && index === form.principals.length - 1"
                          class="principal-action-icon principal-action-add"
                          title="添加"
                          @click="addPrincipal"
                        >
                          <i class="el-icon-circle-plus-outline" />
                        </div>
                        <div
                          class="principal-action-icon principal-action-remove"
                          :class="{ disabled: form.principals.length <= 1 }"
                          title="删除"
                          @click="form.principals.length > 1 && removePrincipal(index)"
                        >
                          <i class="el-icon-remove-outline" />
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="合作开始时间" prop="cooperationStartDate" label-width="120px">
                        <el-date-picker
                          v-model="form.cooperationStartDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择合作开始时间"
                          style="width: 100%;"
                          clearable
                          :disabled="isDetailReadOnly"
                          :picker-options="cooperationStartPickerOptions"
                          @change="handleCooperationDateChange"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="合作结束时间" prop="cooperationEndDate" label-width="120px">
                        <el-date-picker
                          v-model="form.cooperationEndDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择合作结束时间"
                          style="width: 100%;"
                          clearable
                          :disabled="isDetailReadOnly"
                          :picker-options="cooperationEndPickerOptions"
                          @change="handleCooperationDateChange"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="资源保护期" prop="resourceProtectionPeriod" label-width="120px">
                    <el-input
                      v-model="form.resourceProtectionPeriod"
                      placeholder="请输入资源保护期（最多200字）"
                      maxlength="200"
                      show-word-limit
                      clearable
                      :disabled="isDetailReadOnly"
                    />
                  </el-form-item>
                  <el-form-item label="是否顺延" prop="extendEnabled" label-width="120px">
                    <el-radio-group v-model="form.extendEnabled" :disabled="isDetailReadOnly">
                      <el-radio label="Y">是</el-radio>
                      <el-radio label="N">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
              </el-collapse-item>
              <el-collapse-item name="changeRecord" title="变更记录">
                <div class="collapse-placeholder">变更记录</div>
              </el-collapse-item>
            </el-collapse>
          </div>
          </el-tab-pane>
          <el-tab-pane label="校区信息" name="campus">
          <div class="tab-pane-content">
            <el-tabs v-model="editableTabsValue" type="card" class="campus-city-tabs" :editable="!isDetailReadOnly" @edit="handleTabsEdit">
              <el-tab-pane
                v-for="item in editableTabs"
                :key="item.name"
                :label="item.title + '（' + (item.campuses || []).length + '）'"
                :name="item.name"
              >
                <div class="campus-tab-content">
                  <div class="campus-tab-header">
                    <span><span class="campus-tab-title">{{ item.title }}校区信息</span> （校区总数：<span class="campus-stat-total">{{ getCampusStats(item).total }}</span>个&nbsp;&nbsp;&nbsp;&nbsp;启用：<span class="campus-stat-enabled">{{ getCampusStats(item).enabled }}</span>个&nbsp;&nbsp;&nbsp;&nbsp;禁用：<span class="campus-stat-disabled">{{ getCampusStats(item).disabled }}</span>个）</span>
                    <div class="campus-tab-actions">
                      <el-button
                        v-if="!isDetailReadOnly"
                        size="small"
                        icon="el-icon-download"
                        @click="downloadCampusImportTemplate"
                      >
                        导入模板下载
                      </el-button>
                      <el-button
                        v-if="!isDetailReadOnly"
                        size="small"
                        icon="el-icon-upload2"
                        :loading="campusBatchImportLoading"
                        @click="openCampusBatchImport(item)"
                      >
                        批量导入校区
                      </el-button>
                      <el-button v-if="!isDetailReadOnly" type="primary" size="small" icon="el-icon-plus" @click="handleAddCampus(item)">新增校区</el-button>
                    </div>
                  </div>
                  <el-table :data="item.campuses || []" border stripe size="small" class="campus-table">
                    <el-table-column type="index" label="序号" width="55" :index="indexMethodCampus" />
                    <el-table-column prop="promotionId" label="推广ID" min-width="140" show-overflow-tooltip />
                    <el-table-column prop="campusName" label="校区名称" min-width="120" show-overflow-tooltip />
                    <el-table-column prop="shortName" label="校区简称" min-width="100" show-overflow-tooltip />
                    <el-table-column prop="districtName" label="所属行政区（县）" min-width="120" show-overflow-tooltip />
                    <el-table-column label="校区状态" width="140" align="center">
                      <template slot-scope="{ row, $index }">
                        <el-switch
                          v-if="!isDetailReadOnly"
                          v-model="row.statusCode"
                          active-value="ENABLED"
                          inactive-value="DISABLED"
                          active-text="启用"
                          inactive-text="禁用"
                          :class="{ 'campus-status-off': row.statusCode === 'DISABLED' }"
                          @change="handleCampusStatusChange(item, row, $index)"
                        />
                        <span v-else>{{ row.statusCode === 'ENABLED' ? '启用' : '禁用' }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="address" label="校区详细地址" min-width="180" show-overflow-tooltip />
                    <el-table-column v-if="!isDetailReadOnly" label="操作" width="130" align="center">
                      <template slot-scope="{ row, $index }">
                        <el-button type="text" size="small" @click="handleEditCampus(item, $index)">编辑</el-button>
                        <el-button v-if="canShowManageListDelete" type="text" size="small" class="danger-btn" @click="handleDeleteCampus(item, $index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">{{ isDetailReadOnly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!isDetailReadOnly" type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="currentCampusEditIndex >= 0 ? '编辑校区' : '新增校区'" :visible.sync="campusDialogVisible" width="1040px" class="campus-dialog" :close-on-click-modal="false" @close="resetCampusForm">
      <el-form :model="campusForm" :rules="campusRules" ref="campusFormRef" label-width="135px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="推广ID" prop="promotionId">
              <el-input v-model="campusForm.promotionId" placeholder="选择所属行政区（县）后自动生成" readonly style="width: 350px;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="校区名称" prop="campusName">
              <el-input
                v-model="campusForm.campusName"
                placeholder="请输入校区名称"
                maxlength="200"
                show-word-limit
                clearable
                style="width: 350px;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="校区简称" prop="shortName">
              <el-input
                v-model="campusForm.shortName"
                placeholder="请输入校区简称"
                maxlength="20"
                show-word-limit
                clearable
                style="width: 350px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属行政区（县）" prop="locationCode">
              <region-cascader
                ref="campusRegionCascader"
                v-model="campusForm.locationCode"
                placeholder="请选择省市区"
                width="350px"
                @change="onCampusLocationChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="校区状态" prop="statusCode">
              <el-select v-model="campusForm.statusCode" placeholder="请选择校区状态" style="width: 350px;" clearable>
                <el-option label="启用" value="ENABLED" />
                <el-option label="禁用" value="DISABLED" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="校区详细地址" prop="address">
          <el-input
            type="textarea"
            v-model="campusForm.address"
            :rows="3"
            placeholder="请输入校区详细地址"
            maxlength="500"
            show-word-limit
            clearable
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="campusDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleCampusSubmit" :loading="campusSubmitLoading">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="导入失败清单"
      :visible.sync="campusImportFailureDialogVisible"
      width="760px"
      :close-on-click-modal="false"
    >
      <el-table :data="campusImportFailureRows" border stripe size="small" max-height="420">
        <el-table-column prop="seq" label="序号" width="80" />
        <el-table-column prop="campusName" label="校区名称" min-width="180" show-overflow-tooltip />
        <el-table-column prop="reason" label="失败原因" min-width="320" show-overflow-tooltip />
      </el-table>
      <span slot="footer">
        <el-button @click="campusImportFailureDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <input
      ref="campusBatchImportInput"
      type="file"
      accept=".xlsx,.xls"
      style="display: none;"
      @change="handleCampusBatchImportFileChange"
    />
  </div>
</template>

<script>
import api from '../services/api';
import RegionCascader from '@/components/RegionCascader.vue';
import { canShowOrgStaffStudentListDelete, getAccount, getRoleCode, getUserRole } from '@/utils/sessionAuth';

const CAMPUS_TABS_INITIAL = [
  '天津', '北京', '上海', '广州', '深圳', '武汉', '西安', '杭州', '南京', '合肥', '济南', '重庆', '成都',
  '石家庄', '青岛', '哈尔滨', '长沙', '郑州', '苏州', '宁波', '长春', '南昌', '太原', '沈阳',
  '兰州', '银川', '乌鲁木齐', '南宁', '厦门', '呼和浩特', '贵阳', '昆明', '佛山', '福州', '东莞',
  '无锡', '南通', '大连', '吉林', '台北', '海口', '综合'
].map(name => ({ name, title: name }));
const ORG_REMARK_MAX_LENGTH = 2000;

export default {
  name: 'OrgManage',
  components: {
    RegionCascader
  },
  data() {
    const validateCooperationDateRange = (rule, value, callback) => {
      const start = this.form.cooperationStartDate;
      const end = this.form.cooperationEndDate;
      if (!start || !end) {
        callback();
        return;
      }
      const startTime = new Date(start).getTime();
      const endTime = new Date(end).getTime();
      if (Number.isNaN(startTime) || Number.isNaN(endTime)) {
        callback();
        return;
      }
      if (startTime > endTime) {
        callback(new Error('合作开始时间不能晚于合作结束时间'));
        return;
      }
      callback();
    };

    return {
      ORG_REMARK_MAX_LENGTH,
      loading: false,
      submitLoading: false,
      searchLoading: false,
      deleteLoading: false,
      batchDeleteLoading: false,
      tableData: [],
      selectedRows: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        orgName: '',
        teachModeCode: '',
        statusCode: ''
      },
      dialogVisible: false,
      dialogTitle: '新增机构',
      isEdit: false,
      /** 详情弹窗：表单只读，仅关闭 */
      isDetailReadOnly: false,
      /** 机构弹窗详情异步加载序列号，防止连续点击不同机构导致旧请求覆盖新状态 */
      orgDialogLoadSeq: 0,
      editId: null,
      activeTab: 'campus',
      businessActiveNames: ['cooperationInfo'],
      editableTabsValue: CAMPUS_TABS_INITIAL[0].name,
      editableTabs: JSON.parse(JSON.stringify(CAMPUS_TABS_INITIAL)).map(t => ({ ...t, campuses: [] })),
      form: {
        orgCode: '',
        orgName: '',
        mainProjectCodes: [],
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        statusCode: 'RUNNING',
        principals: [{ name: '', phone: '' }],
        cooperationStartDate: '',
        cooperationEndDate: '',
        resourceProtectionPeriod: '',
        extendEnabled: 'Y',
        remark: ''
      },
      rules: {
        orgCode: [{ required: true, message: '机构编码为必填', trigger: ['blur', 'change'] }],
        orgName: [{ required: true, message: '请输入机构品牌', trigger: ['blur', 'change'] }],
        teachModeCode: [{ required: true, message: '请选择授课方式', trigger: ['blur', 'change'] }],
        mainProjectCodes: [{ required: true, message: '请选择主营项目', trigger: ['blur', 'change'] }],
        principalName: [{ required: true, message: '请输入负责人姓名', trigger: ['blur', 'change'] }],
        principalPhone: [
          { required: true, message: '请输入负责人电话', trigger: ['blur', 'change'] },
          { pattern: /^(1[3-9]\d{9}|0\d{2,3}-?\d{7,8})$/, message: '请输入正确的手机号或固话格式（11位手机号或区号+号码）', trigger: ['blur', 'change'] }
        ],
        principals: [
          { required: true, type: 'array', min: 1, message: '至少保留一条负责人', trigger: ['blur', 'change'] },
          { type: 'array', max: 5, message: '最多5个负责人', trigger: ['blur', 'change'] }
        ],
        cooperationStartDate: [
          { required: true, message: '请选择合作开始时间', trigger: ['blur', 'change'] },
          { validator: validateCooperationDateRange, trigger: ['blur', 'change'] }
        ],
        cooperationEndDate: [
          { required: true, message: '请选择合作结束时间', trigger: ['blur', 'change'] },
          { validator: validateCooperationDateRange, trigger: ['blur', 'change'] }
        ],
        resourceProtectionPeriod: [{ max: 200, message: '资源保护期最多200字', trigger: ['blur', 'change'] }],
        remark: [{ max: ORG_REMARK_MAX_LENGTH, message: `备注最多${ORG_REMARK_MAX_LENGTH}字`, trigger: ['blur', 'change'] }]
      },
      projectOptions: [],
      projectMap: {},
      campusDialogVisible: false,
      campusSubmitLoading: false,
      campusBatchImportLoading: false,
      campusImportFailureDialogVisible: false,
      campusImportFailureRows: [],
      currentBatchImportTabName: '',
      currentCampusTab: null,
      currentCampusEditIndex: -1,
      campusForm: {
        promotionId: '',
        campusName: '',
        locationCode: '',
        shortName: '',
        address: '',
        statusCode: 'DISABLED'
      },
      campusRules: {
        promotionId: [{ required: true, message: '推广ID为必填，请先选择所属行政区（县）', trigger: ['blur', 'change'] }],
        campusName: [{ required: true, message: '请输入校区名称', trigger: ['blur', 'change'] }],
        locationCode: [{ required: true, message: '请选择所属行政区（县）', trigger: ['blur', 'change'] }],
        shortName: [{ required: true, message: '请输入校区简称', trigger: ['blur', 'change'] }],
        address: [{ required: true, message: '请输入校区详细地址', trigger: ['blur', 'change'] }],
        statusCode: [{ required: true, message: '请选择校区状态', trigger: ['blur', 'change'] }]
      }
    };
  },
  computed: {
    /** 核算人员（FINANCE）仅可查看详情，不可新增、不可编辑机构 */
    canShowOrgWriteActions() {
      const rc = (getRoleCode() || '').trim();
      const ur = (getUserRole() || '').trim();
      return rc !== 'FINANCE' && ur !== 'FINANCE';
    },
    canShowOrgRowEdit() {
      return this.canShowOrgWriteActions;
    },
    canShowManageListDelete() {
      return canShowOrgStaffStudentListDelete();
    },
    /** 商务人员（BUSINESS）及超级管理员、系统管理员可见机构弹窗「商务信息」页签 */
    canShowOrgBusinessTab() {
      const rc = (getRoleCode() || '').trim();
      const ur = (getUserRole() || '').trim();
      const acc = (getAccount() || '').trim().toLowerCase();
      if (rc === 'BUSINESS' || ur === 'BUSINESS') return true;
      if (rc === 'SYSTEM_ADMIN' || ur === 'SYSTEM_ADMIN') return true;
      if (rc === 'admin' || ur === 'admin') return true;
      if (acc === 'admin') return true;
      return false;
    },
    /** 无商务页签时不校验合作/负责人等字段（表单项随页签卸载，规则一并收紧） */
    orgDialogRules() {
      const r = this.rules;
      if (this.canShowOrgBusinessTab) return r;
      return {
        orgCode: r.orgCode,
        orgName: r.orgName,
        teachModeCode: r.teachModeCode,
        mainProjectCodes: r.mainProjectCodes,
        resourceProtectionPeriod: r.resourceProtectionPeriod
      };
    },
    cooperationStartPickerOptions() {
      const end = this.form.cooperationEndDate;
      return {
        disabledDate: (time) => {
          if (!end) return false;
          const endDate = new Date(end);
          endDate.setHours(0, 0, 0, 0);
          const t = new Date(time);
          t.setHours(0, 0, 0, 0);
          return t > endDate;
        }
      };
    },
    cooperationEndPickerOptions() {
      const start = this.form.cooperationStartDate;
      return {
        disabledDate: (time) => {
          if (!start) return false;
          const startDate = new Date(start);
          startDate.setHours(0, 0, 0, 0);
          const t = new Date(time);
          t.setHours(0, 0, 0, 0);
          return t < startDate;
        }
      };
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    /** 先加载主营项目字典再拉列表，避免表格先渲染时 projectMap 为空显示 CODE */
    async initPage() {
      this.loading = true;
      try {
        await this.loadProjectOptions();
        await this.loadData();
      } finally {
        this.loading = false;
      }
    },
    handleCooperationDateChange() {
      if (!this.$refs.form || !this.canShowOrgBusinessTab) return;
      this.$nextTick(() => {
        this.$refs.form.validateField('cooperationStartDate');
        this.$refs.form.validateField('cooperationEndDate');
      });
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    syncOrgDialogActiveTab() {
      this.activeTab = this.canShowOrgBusinessTab ? 'business' : 'campus';
    },
    orgRowSelectable() {
      return this.canShowManageListDelete;
    },
    async loadProjectOptions() {
      try {
        const res = await api.post('/dictionary', { tags: ['MAIN_PROJECT'] });
        if (res.data.success) {
          const dict = res.data.data || {};
          const list = dict.MAIN_PROJECT || [];
          const categories = list.filter(item => !item.parent_code);
          const items = list.filter(item => item.parent_code);
          
          this.projectOptions = categories.map(cat => ({
            value: cat.code,
            label: cat.name,
            children: items.filter(item => item.parent_code === cat.code).map(item => ({
              value: item.code,
              label: item.name
            }))
          }));
          
          list.forEach(item => {
            this.projectMap[item.code] = item.name;
          });
        }
      } catch (e) {
        console.error('加载主营项目失败', e);
      }
    },
    formatMainProjects(codes) {
      if (!codes) return '';
      try {
        const arr = typeof codes === 'string' ? JSON.parse(codes) : codes;
        if (!Array.isArray(arr)) return '';
        return arr.map(code => this.projectMap[code] || code).join('、');
      } catch (e) {
        return '';
      }
    },
    openCampusBatchImport(tabItem) {
      if (this.isDetailReadOnly) return;
      if (!tabItem || !tabItem.name) return;
      this.currentBatchImportTabName = tabItem.name;
      const input = this.$refs.campusBatchImportInput;
      if (!input) return;
      input.value = '';
      input.click();
    },
    async handleCampusBatchImportFileChange(event) {
      const input = event && event.target ? event.target : this.$refs.campusBatchImportInput;
      const file = input && input.files && input.files[0] ? input.files[0] : null;
      if (!file) return;
      const tab = (this.editableTabs || []).find(t => t.name === this.currentBatchImportTabName);
      if (!tab) {
        this.$message.error('未找到当前城市页签，请重试');
        return;
      }
      this.campusBatchImportLoading = true;
      try {
        const parsed = await this.parseCampusBatchImportRaw(file);
        if (this.isEdit && this.editId) {
          await this.importCampusesByBackend(tab, parsed.rows);
        } else {
          await this.importCampusesByBackendValidate(tab, parsed.rows);
        }
      } catch (e) {
        this.$message.error((e && e.message) || '批量导入失败');
      } finally {
        this.campusBatchImportLoading = false;
        if (input) input.value = '';
      }
    },
    parseCampusBatchImportRaw(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (evt) => {
          try {
            const XLSX = require('xlsx');
            const workbook = XLSX.read(evt.target.result, { type: 'array' });
            const firstSheetName = workbook.SheetNames && workbook.SheetNames[0];
            if (!firstSheetName) {
              throw new Error('Excel 中未找到工作表');
            }
            const sheet = workbook.Sheets[firstSheetName];
            const aoa = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
            if (!Array.isArray(aoa) || aoa.length === 0) {
              throw new Error('Excel 无有效数据');
            }
            const hasExpectedHeaders = (row) => {
              const set = new Set((row || []).map(v => String(v || '').trim()));
              const hasCampus = set.has('校区名称（必填）') || set.has('校区名称') || set.has('校区名');
              const hasRegion = set.has('所属行政区（县）（必填）') || set.has('所属行政区（县）') || set.has('所属行政区(县)');
              const hasAddress = set.has('校区详细地址（必填）') || set.has('校区详细地址');
              return hasCampus && hasRegion && hasAddress;
            };
            let headerRowIndex = 0;
            if (!hasExpectedHeaders(aoa[0]) && hasExpectedHeaders(aoa[1])) {
              headerRowIndex = 1;
            }
            const list = XLSX.utils.sheet_to_json(sheet, { defval: '', range: headerRowIndex });
            if (!Array.isArray(list) || list.length === 0) {
              throw new Error('Excel 无有效数据');
            }
            const rows = list.map((raw, idx) => ({
              seq: idx + 1,
              campusName: String(raw['校区名称（必填）'] || raw['校区名称'] || raw['校区名'] || '').trim(),
              shortName: String(raw['校区简称'] || '').trim(),
              regionPath: String(raw['所属行政区（县）（必填）'] || raw['所属行政区（县）'] || raw['所属行政区(县)'] || '').trim(),
              address: String(raw['校区详细地址（必填）'] || raw['校区详细地址'] || '').trim()
            }));
            resolve({ rows });
          } catch (e) {
            reject(e);
          }
        };
        reader.onerror = () => reject(new Error('读取Excel文件失败'));
        reader.readAsArrayBuffer(file);
      });
    },
    async importCampusesByBackend(tabItem, rows) {
      const resp = await api.post(`/org/${this.editId}/campus-batch-import`, {
        cityKey: tabItem.name,
        items: rows
      });
      const body = (resp && resp.data) || {};
      if (!body.success) {
        throw new Error(body.message || '批量导入失败');
      }
      const data = body.data || {};
      const inserted = Array.isArray(data.insertedCampuses) ? data.insertedCampuses : [];
      if (!tabItem.campuses) this.$set(tabItem, 'campuses', []);
      if (inserted.length) tabItem.campuses.push(...inserted);
      const success = Number(data.successCount || 0);
      const failures = Array.isArray(data.failList) ? data.failList : [];
      const failCount = Number(data.failCount || failures.length || 0);
      this.$message[failCount > 0 ? 'warning' : 'success'](`导入完成：成功 ${success} 条，失败 ${failCount} 条`);
      if (failures.length) {
        this.openCampusImportFailureDialog(failures);
      } else {
        this.campusImportFailureDialogVisible = false;
      }
    },
    collectEditableCampusNames() {
      const names = [];
      (this.editableTabs || []).forEach(tab => {
        (tab && Array.isArray(tab.campuses) ? tab.campuses : []).forEach(campus => {
          const n = String(campus && campus.campusName ? campus.campusName : '').trim();
          if (n) names.push(n);
        });
      });
      return names;
    },
    async importCampusesByBackendValidate(tabItem, rows) {
      const resp = await api.post('/org/campus-batch-validate', {
        orgCode: this.form.orgCode,
        items: rows,
        existingCampusNames: this.collectEditableCampusNames()
      });
      const body = (resp && resp.data) || {};
      if (!body.success) {
        throw new Error(body.message || '批量预处理失败');
      }
      const data = body.data || {};
      const campuses = Array.isArray(data.campuses) ? data.campuses : [];
      if (!tabItem.campuses) this.$set(tabItem, 'campuses', []);
      if (campuses.length) tabItem.campuses.push(...campuses);
      const success = Number(data.successCount || 0);
      const failures = Array.isArray(data.failList) ? data.failList : [];
      const failCount = Number(data.failCount || failures.length || 0);
      this.$message[failCount > 0 ? 'warning' : 'success'](`导入完成：成功 ${success} 条，失败 ${failCount} 条`);
      if (failures.length) {
        this.openCampusImportFailureDialog(failures);
      } else {
        this.campusImportFailureDialogVisible = false;
      }
    },
    openCampusImportFailureDialog(failures) {
      this.campusImportFailureRows = (failures || []).map(item => ({
        seq: item.seq,
        campusName: item.campusName || '',
        reason: item.reason || ''
      }));
      this.campusImportFailureDialogVisible = true;
    },
    downloadCampusImportTemplate() {
      const XLSX = require('xlsx-js-style');
      const ruleText = [
        '导入规则提示：',
        '1、请务必填写：校区名称、所属行政区（县）、校区详细地址；',
        '2、推广ID无需填写，由平台自动生成；',
        '3、相同【校区名称】的会被认为是重复数据，不会重复导入！',
        '4、【所属行政区（县）】不合规时将被限制导入！',
        '5、单次导入数据不超过500条！'
      ].join('\n');
      const headers = [
        '推广ID（系统自动生成，无需填写）',
        '校区名称（必填）',
        '校区简称',
        '所属行政区（县）（必填）',
        '校区状态',
        '校区详细地址（必填）'
      ];
      const sample = [
        '',
        '中关村学校区',
        '中关村学校区',
        '北京市-海淀区',
        '启用',
        '北京市海淀区丹棱街7号'
      ];
      const ws = XLSX.utils.aoa_to_sheet([
        [ruleText],
        headers,
        sample
      ]);
      ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
      ws['!freeze'] = { xSplit: 0, ySplit: 1, topLeftCell: 'A2', activePane: 'bottomLeft', state: 'frozen' };
      ws['!cols'] = headers.map(() => ({ wch: 35 }));
      ws['!rows'] = [{ hpt: 140 }];
      if (!ws.A1) ws.A1 = { t: 's', v: ruleText };
      ws.A1.s = {
        font: { sz: 11, color: { rgb: 'FF7D00' }, bold: true },
        alignment: { vertical: 'center', horizontal: 'left', wrapText: true }
      };
      headers.forEach((headerText, colIndex) => {
        const text = String(headerText || '');
        if (!text.includes('（必填）') && !text.includes('(必填)')) return;
        const cellAddress = XLSX.utils.encode_cell({ r: 1, c: colIndex });
        if (!ws[cellAddress]) ws[cellAddress] = { t: 's', v: text };
        ws[cellAddress].s = {
          ...(ws[cellAddress].s || {}),
          font: {
            ...(((ws[cellAddress].s || {}).font) || {}),
            color: { rgb: 'FF0000' },
            bold: true
          }
        };
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '校区导入模板');
      const now = new Date();
      const dateStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
      XLSX.writeFile(wb, `校区导入模板-${dateStr}.xlsx`);
      this.$message.success('导入模板已下载');
    },
    async loadData() {
      this.loading = true;
      try {
        const res = await api.post('/org/list', {
          ...this.searchForm,
          page: this.currentPage,
          pageSize: this.pageSize
        });
        if (res.data.success) {
          this.tableData = res.data.data.list || [];
          this.total = res.data.data.total || 0;
        }
      } catch (e) {
        this.$message.error('加载数据失败');
      }
      this.loading = false;
    },
    async handleSearch() {
      this.searchLoading = true;
      this.currentPage = 1;
      await this.loadData();
      this.searchLoading = false;
    },
    handleReset() {
      this.searchForm = { orgName: '', teachModeCode: '', statusCode: '' };
      this.handleSearch();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.loadData();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    handleAdd() {
      if (!this.canShowOrgWriteActions) return;
      this.orgDialogLoadSeq += 1;
      this.dialogTitle = '新增机构';
      this.isEdit = false;
      this.isDetailReadOnly = false;
      this.editId = null;
      this.dialogVisible = true;
    },
    async onDialogOpen() {
      this.syncOrgDialogActiveTab();
      if (!this.isEdit) {
        try {
          const res = await api.post('/org/next-code', {});
          if (res.data.success && res.data.data) {
            this.form.orgCode = res.data.data.nextCode || '';
          }
        } catch (e) {
          console.error('获取机构编码失败', e);
          this.$message.error('获取机构编码失败');
        }
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    async handleDetail(row) {
      const loadSeq = this.orgDialogLoadSeq + 1;
      this.orgDialogLoadSeq = loadSeq;
      this.dialogTitle = '机构详情';
      this.isEdit = true;
      this.editId = row.orgId;
      this.isDetailReadOnly = true;
      await this.applyOrgRowToForm(row, { loadSeq, targetOrgId: row.orgId });
      if (loadSeq !== this.orgDialogLoadSeq) return;
      this.dialogVisible = true;
    },
    async handleEdit(row) {
      if (!this.canShowOrgWriteActions) return;
      const loadSeq = this.orgDialogLoadSeq + 1;
      this.orgDialogLoadSeq = loadSeq;
      this.dialogTitle = '编辑机构';
      this.isEdit = true;
      this.editId = row.orgId;
      this.isDetailReadOnly = false;
      await this.applyOrgRowToForm(row, { loadSeq, targetOrgId: row.orgId });
      if (loadSeq !== this.orgDialogLoadSeq) return;
      this.dialogVisible = true;
    },
    async applyOrgRowToForm(row, options = {}) {
      const expectedLoadSeq = options.loadSeq;
      const targetOrgId = options.targetOrgId != null ? String(options.targetOrgId) : '';
      const stale = () => {
        if (expectedLoadSeq != null && expectedLoadSeq !== this.orgDialogLoadSeq) return true;
        if (targetOrgId && String(this.editId || '') !== targetOrgId) return true;
        return false;
      };
      let detailRow = { ...row };
      try {
        const detailRes = await api.post(`/org/${row.orgId}`, {});
        if (detailRes.data && detailRes.data.success && detailRes.data.data) {
          detailRow = { ...detailRow, ...detailRes.data.data };
        }
      } catch (e) {
        console.error('加载机构详情失败', e);
      }
      if (stale()) return;

      let mainProjectCodes = [];
      if (detailRow.mainProjectCodes) {
        try {
          mainProjectCodes = typeof detailRow.mainProjectCodes === 'string'
            ? JSON.parse(detailRow.mainProjectCodes)
            : detailRow.mainProjectCodes;
        } catch (e) {
          mainProjectCodes = [];
        }
      }

      const principals = this.parsePrincipalsFromRow(detailRow);
      const organCampuses = detailRow.organCampuses && typeof detailRow.organCampuses === 'object'
        ? detailRow.organCampuses
        : {};
      const initialTabs = JSON.parse(JSON.stringify(CAMPUS_TABS_INITIAL));
      const extraTabs = Object.keys(organCampuses)
        .filter(key => !initialTabs.some(t => t.name === key))
        .map(key => ({ name: key, title: key }));
      this.editableTabs = [...initialTabs, ...extraTabs].map(t => ({
        ...t,
        campuses: Array.isArray(organCampuses[t.name]) ? organCampuses[t.name] : []
      }));
      this.editableTabsValue = this.editableTabs[0].name;

      this.form = {
        orgCode: detailRow.orgCode || '',
        orgName: detailRow.orgName,
        teachModeCode: detailRow.teachModeCode,
        mainProjectCodes: mainProjectCodes,
        provinceCode: detailRow.provinceCode || '',
        cityCode: detailRow.cityCode || '',
        districtCode: detailRow.districtCode || '',
        statusCode: detailRow.statusCode,
        principals,
        cooperationStartDate: detailRow.cooperationStartDate || '',
        cooperationEndDate: detailRow.cooperationEndDate || '',
        resourceProtectionPeriod: detailRow.resourceProtectionPeriod || '',
        extendEnabled: detailRow.extendEnabled !== undefined && detailRow.extendEnabled !== null ? detailRow.extendEnabled : 'Y',
        remark: detailRow.remark || ''
      };
    },
    parsePrincipalsFromRow(row) {
      const list = [];
      const first = { name: row.principalName || '', phone: row.principalPhone || '' };
      list.push(first);
      const contact = (row.principalContact || '').trim();
      if (contact) {
        contact.split(';').forEach(s => {
          const part = s.trim();
          if (!part) return;
          const comma = part.indexOf(',');
          if (comma >= 0) {
            list.push({ name: part.slice(0, comma).trim(), phone: part.slice(comma + 1).trim() });
          } else {
            list.push({ name: part, phone: '' });
          }
        });
      }
      return list.length ? list : [{ name: '', phone: '' }];
    },
    addPrincipal() {
      if (this.form.principals.length >= 5) return;
      this.form.principals.push({ name: '', phone: '' });
    },
    removePrincipal(index) {
      if (this.form.principals.length <= 1) return;
      this.form.principals.splice(index, 1);
    },
    async handleTabsEdit(targetName, action) {
      if (this.isDetailReadOnly) return;
      if (action === 'add') {
        const name = '新校区_' + Date.now();
        this.editableTabs.push({ name, title: '新校区', campuses: [] });
        this.editableTabsValue = name;
      } else if (action === 'remove') {
        try {
          await this.$confirm('确定删除该选项卡吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } catch (e) {
          if (e === 'cancel') return;
        }
        const tabs = this.editableTabs;
        const idx = tabs.findIndex(t => t.name === targetName);
        if (idx === -1) return;
        tabs.splice(idx, 1);
        if (this.editableTabsValue === targetName && tabs.length) {
          this.editableTabsValue = tabs[idx === 0 ? 0 : idx - 1].name;
        }
      }
    },
    indexMethodCampus(index) {
      return index + 1;
    },
    getCampusStats(tabItem) {
      const list = tabItem.campuses || [];
      const total = list.length;
      const enabled = list.filter(c => c.statusCode === 'ENABLED').length;
      const disabled = total - enabled;
      return { total, enabled, disabled };
    },
    buildOrganCampusesMap() {
      const result = {};
      (this.editableTabs || []).forEach(tab => {
        result[tab.name] = tab.campuses || [];
      });
      return result;
    },
    async handleCampusStatusChange(tabItem, row, campusIndex) {
      if (this.isDetailReadOnly || !this.isEdit || !this.editId) return;
      const oldStatus = row.statusCode === 'ENABLED' ? 'DISABLED' : 'ENABLED';
      try {
        const res = await api.post(`/org/${this.editId}/campus-status`, {
          cityKey: tabItem.name,
          campusIndex,
          statusCode: row.statusCode
        });
        if (!res.data || !res.data.success) {
          this.$set(row, 'statusCode', oldStatus);
          this.$message.error((res.data && res.data.message) || '更新校区状态失败');
        }
      } catch (e) {
        this.$set(row, 'statusCode', oldStatus);
        this.$message.error('更新校区状态失败');
      }
    },
    handleAddCampus(tabItem) {
      if (this.isDetailReadOnly) return;
      this.currentCampusTab = tabItem;
      this.currentCampusEditIndex = -1;
      this.resetCampusForm();
      this.campusDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.campusFormRef && this.$refs.campusFormRef.clearValidate();
      });
    },
    resetCampusForm() {
      this.currentCampusEditIndex = -1;
      this.campusForm = {
        promotionId: '',
        campusName: '',
        locationCode: '',
        shortName: '',
        address: '',
        statusCode: 'DISABLED'
      };
      this.$refs.campusFormRef && this.$refs.campusFormRef.resetFields();
    },
    onCampusLocationChange(locationCode) {
      const orgCode = this.form.orgCode || '';
      const areaCode = this.$refs.campusRegionCascader && this.$refs.campusRegionCascader.getAreaCode
        ? this.$refs.campusRegionCascader.getAreaCode(locationCode)
        : '';
      this.campusForm.promotionId = orgCode && areaCode ? `${orgCode}_${areaCode}` : '';
    },
    async handleCampusSubmit() {
      let valid = false;
      try {
        valid = await new Promise(resolve => {
          this.$refs.campusFormRef.validate(v => resolve(v));
        });
      } catch (e) {
        valid = false;
      }
      if (!valid) return;
      const districtName = this.$refs.campusRegionCascader && this.$refs.campusRegionCascader.getFullPathNames
        ? this.$refs.campusRegionCascader.getFullPathNames(this.campusForm.locationCode)
        : '';
      if (!this.currentCampusTab.campuses) this.currentCampusTab.campuses = [];
      const oldRow = this.currentCampusEditIndex >= 0
        ? (this.currentCampusTab.campuses[this.currentCampusEditIndex] || {})
        : {};
      const row = {
        promotionId: this.campusForm.promotionId || '',
        campusName: this.campusForm.campusName,
        districtName,
        shortName: this.campusForm.shortName,
        address: this.campusForm.address,
        statusCode: this.campusForm.statusCode,
        locationCode: this.campusForm.locationCode || '',
        longitude: oldRow.longitude != null ? oldRow.longitude : null,
        latitude: oldRow.latitude != null ? oldRow.latitude : null,
        longitudeTencent:
          oldRow.longitudeTencent != null ? oldRow.longitudeTencent : null,
        latitudeTencent:
          oldRow.latitudeTencent != null ? oldRow.latitudeTencent : null
      };
      if (this.isEdit && this.editId) {
        this.campusSubmitLoading = true;
        try {
          const res = await api.post(`/org/${this.editId}/campus-upsert`, {
            cityKey: this.currentCampusTab.name,
            campusIndex: this.currentCampusEditIndex >= 0 ? this.currentCampusEditIndex : undefined,
            campus: row
          });
          if (!res.data || !res.data.success) {
            this.$message.error((res.data && res.data.message) || '保存校区失败');
            return;
          }
          const data = (res.data && res.data.data) || {};
          const savedRow = data.campus || row;
          const savedIndex = Number(data.campusIndex);
          if (this.currentCampusEditIndex >= 0) {
            this.$set(this.currentCampusTab.campuses, this.currentCampusEditIndex, savedRow);
          } else if (!Number.isNaN(savedIndex) && savedIndex >= 0 && savedIndex <= this.currentCampusTab.campuses.length) {
            this.currentCampusTab.campuses.splice(savedIndex, 0, savedRow);
          } else {
            this.currentCampusTab.campuses.push(savedRow);
          }
          this.$message.success('校区保存成功');
          this.campusDialogVisible = false;
        } catch (e) {
          this.$message.error('保存校区失败');
        } finally {
          this.campusSubmitLoading = false;
        }
        return;
      }
      if (this.currentCampusEditIndex >= 0) {
        this.$set(this.currentCampusTab.campuses, this.currentCampusEditIndex, row);
      } else {
        this.currentCampusTab.campuses.push(row);
      }
      this.campusDialogVisible = false;
    },
    handleEditCampus(tabItem, index) {
      if (this.isDetailReadOnly) return;
      this.currentCampusTab = tabItem;
      this.currentCampusEditIndex = index;
      const row = tabItem.campuses[index] || {};
      const orgCode = this.form.orgCode || '';
      const areaCode = this.$refs.campusRegionCascader && this.$refs.campusRegionCascader.getAreaCode
        ? this.$refs.campusRegionCascader.getAreaCode(row.locationCode)
        : '';
      const promotionId = row.promotionId || (orgCode && areaCode ? `${orgCode}_${areaCode}` : '');
      this.campusForm = {
        promotionId,
        campusName: row.campusName || '',
        locationCode: row.locationCode || '',
        shortName: row.shortName || '',
        address: row.address || '',
        statusCode: row.statusCode || 'DISABLED'
      };
      this.campusDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.campusFormRef && this.$refs.campusFormRef.clearValidate();
        if (this.$refs.campusRegionCascader && this.campusForm.locationCode) {
          this.$refs.campusRegionCascader.setValue(this.campusForm.locationCode);
        }
      });
    },
    async handleDeleteCampus(tabItem, index) {
      if (this.isDetailReadOnly || !this.canShowManageListDelete) return;
      try {
        await this.$confirm('确定删除该校区吗？', '提示', { type: 'warning' });
      } catch (e) {
        if (e === 'cancel') return;
      }
      if (!tabItem || !Array.isArray(tabItem.campuses) || index < 0 || index >= tabItem.campuses.length) {
        this.$message.error('校区不存在或已删除');
        return;
      }
      if (this.isEdit && this.editId) {
        try {
          const res = await api.post(`/org/${this.editId}/campus-remove`, {
            cityKey: tabItem.name,
            campusIndex: index
          });
          if (!res.data || !res.data.success) {
            this.$message.error((res.data && res.data.message) || '删除校区失败');
            return;
          }
          tabItem.campuses.splice(index, 1);
          this.$message.success('删除成功');
        } catch (e) {
          this.$message.error('删除校区失败');
        }
        return;
      }
      tabItem.campuses.splice(index, 1);
      this.$message.success('删除成功');
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该机构吗？', '提示', { type: 'warning' });
        this.deleteLoading = true;
        const res = await api.post(`/org/${row.orgId}/remove`);
        if (res.data.success) {
          this.$message.success('删除成功');
          this.loadData();
        } else {
          this.$message.error(res.data.message || '删除失败');
        }
      } catch (e) {
        if (e !== 'cancel') this.$message.error('删除失败');
      } finally {
        this.deleteLoading = false;
      }
    },
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(`确定删除选中的 ${this.selectedRows.length} 条记录吗？`, '提示', { type: 'warning' });
        this.batchDeleteLoading = true;
        let successCount = 0;
        for (const row of this.selectedRows) {
          try {
            const res = await api.post(`/org/${row.orgId}/remove`);
            if (res.data.success) successCount++;
          } catch (e) {
            console.error('删除失败', e);
          }
        }
        this.$message.success(`成功删除 ${successCount} 条记录`);
        this.loadData();
      } catch (e) {
        if (e !== 'cancel') this.$message.error('批量删除失败');
      } finally {
        this.batchDeleteLoading = false;
      }
    },
    async handleSubmit() {
      if (this.isDetailReadOnly) return;
      try {
        await this.$refs.form.validate();
      } catch (e) {
        const invalidProps = e && typeof e === 'object' ? Object.keys(e) : [];
        const hasBusinessRequiredError = invalidProps.some(prop =>
          prop.startsWith('principals.') || prop === 'cooperationStartDate' || prop === 'cooperationEndDate'
        );
        if (hasBusinessRequiredError && this.canShowOrgBusinessTab) {
          this.activeTab = 'business';
          this.businessActiveNames = ['cooperationInfo'];
        }
        this.$nextTick(() => {
          const errorEl = document.querySelector('.el-form-item.is-error');
          if (errorEl) {
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
        return;
      }
      this.submitLoading = true;
      try {
        const principals = this.form.principals || [];
        const principalName = principals[0] ? principals[0].name : '';
        const principalPhone = principals[0] ? principals[0].phone : '';
        const principalContact = principals.length > 1
          ? principals.slice(1).map(p => `${(p.name || '').trim()},${(p.phone || '').trim()}`).join(';')
          : '';
        
        const submitData = {
          ...this.form,
          principalName,
          principalPhone,
          principalContact
        };
        if (!this.isEdit) {
          submitData.organCampuses = this.buildOrganCampusesMap();
        }
        delete submitData.principals;
        
        let res;
        if (this.isEdit) {
          res = await api.post(`/org/${this.editId}/update`, submitData);
        } else {
          res = await api.post('/org/add', submitData);
        }
        if (res.data.success) {
          this.$message.success(this.isEdit ? '更新成功' : '新增成功');
          this.dialogVisible = false;
          this.loadData();
        } else {
          this.$message.error(res.data.message || '操作失败');
        }
      } catch (e) {
        this.$message.error('操作失败');
      }
      this.submitLoading = false;
    },
    resetForm() {
      this.orgDialogLoadSeq += 1;
      this.isDetailReadOnly = false;
      this.syncOrgDialogActiveTab();
      this.businessActiveNames = ['cooperationInfo'];
      this.editableTabs = JSON.parse(JSON.stringify(CAMPUS_TABS_INITIAL)).map(t => ({ ...t, campuses: [] }));
      this.editableTabsValue = CAMPUS_TABS_INITIAL[0].name;
      this.form = {
        orgCode: '',
        orgName: '',
        mainProjectCodes: [],
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        statusCode: 'RUNNING',
        principals: [{ name: '', phone: '' }],
        cooperationStartDate: '',
        cooperationEndDate: '',
        resourceProtectionPeriod: '',
        extendEnabled: 'Y',
        remark: ''
      };
      this.$refs.form && this.$refs.form.resetFields();
    }
  }
};
</script>

<style scoped>
.org-manage {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding-bottom: 56px;
}

.search-area {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
}

.search-form {
  flex: 1;
}

.btn-group {
  display: flex;
  gap: 10px;
}

.table-card {
  margin-top: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.table-card >>> .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}

.table-card >>> .el-table {
  flex: 1;
}

.danger-btn {
  color: #F56C6C;
}

.danger-btn:hover {
  color: #f78989;
}

.org-dialog-first-row {
  flex-wrap: nowrap;
}

.org-dialog-first-row .el-col {
  min-width: 260px;
}

.org-dialog-first-row .el-form-item__content .el-input,
.org-dialog-first-row .el-form-item__content .el-select,
.org-dialog-first-row .el-form-item__content .el-cascader {
  min-width: 200px;
}

.org-dialog-tabs {
  margin-top: 8px;
}

.org-dialog-tabs >>> .el-tabs__header {
  margin-bottom: 12px;
}

.tab-pane-content {
  padding: 8px 0;
}

.principal-row {
  margin-bottom: 4px;
}

.principal-row .el-row {
  display: flex;
  align-items: center;
}

.principal-actions-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 32px;
}

.principal-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.principal-action-icon {
  cursor: pointer;
  font-size: 20px;
  padding: 4px;
  line-height: 1;
}

.principal-action-icon.principal-action-add {
  color: #67c23a;
}

.principal-action-icon.principal-action-add:hover {
  color: #85ce61;
}

.principal-action-icon.principal-action-remove {
  color: #f56c6c;
}

.principal-action-icon.principal-action-remove:hover:not(.disabled) {
  color: #f78989;
}

.principal-action-icon.principal-action-remove.disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.campus-city-tabs >>> .el-tabs__item {
  width: 120px !important;
  min-width: 120px !important;
}

.campus-dialog >>> .el-dialog__body {
  overflow-x: hidden;
  padding-right: 20px;
  box-sizing: border-box;
  max-width: 100%;
}

.campus-tab-content {
  padding: 12px 0;
  color: #606266;
  font-size: 14px;
}

.campus-tab-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.campus-tab-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.campus-tab-title {
  font-size: 16px;
}

.campus-stat-total {
  color: #409EFF;
  font-weight: 500;
}

.campus-stat-enabled {
  color: #67c23a;
  font-weight: 500;
}

.campus-stat-disabled {
  color: #f56c6c;
  font-weight: 500;
}

.campus-table {
  margin-top: 0;
}

.campus-status-off >>> .el-switch__core {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}

.tab-placeholder {
  color: #909399;
  font-size: 13px;
  padding: 16px 0;
}

.org-business-collapse >>> .el-collapse-item__content {
  padding: 16px 12px 8px;
}

.collapse-placeholder {
  color: #909399;
  font-size: 13px;
  padding: 8px 0;
}
</style>
